export const REQUIRED_ACTION_TYPES_BOOKING = ['authorizeBooking'] as const
export const REQUIRED_ACTION_TYPES_SHIPMENT = [
  'completePackingList', // documentUpload
  'provideCommercialInvoice', // documentUpload
  'provideIncoTerms', // optionChoice
  // Outdated
  'provideCustomsWarrant', // downloadTemplateSignUpload!
  'provideSupplierInformation', // dataInput
  'provideContainerNumbers', // dataInput
  'provideSealNumbers', // dataInput
  'provideBLType', // optionChoice
  'provideConsigneeInformation', // dataInput
  'providePickupDetails', // dataInput
  'provideDeliveryDetails', // dataInput
  // Outdated
  'provideFbaData', // dataInput
  // IMPORT
  'provideCustomsWarrantBelgiumFiscal', // downloadTemplateSignUpload
  'provideCustomsWarrantBelgiumPOA', // downloadTemplateSignUpload
  'provideCustomsWarrantNetherlandsFiscal', // downloadTemplateSignUpload
  'provideCustomsWarrantNetherlandsPOA', // downloadTemplateSignUpload
  'provideCustomsWarrantGermanySeaPOA', // downloadTemplateSignUpload
  'provideCustomsWarrantGermanyAirPOA', // downloadTemplateSignUpload
  'provideCustomsWarrantSelfCustomsDeclaration', // downloadTemplateSignUpload
  // EXPORT
  'provideCustomsWarrantBelgiumExportPOA', // downloadTemplateSignUpload
  'provideCustomsWarrantGermanyExportPOA', // downloadTemplateSignUpload
  'provideCustomsWarrantGermanyAirExportPOA', // downloadTemplateSignUpload!
  'provideCustomsWarrantNetherlandsExportPOA', // downloadTemplateSignUpload
  'providePaymentProof', // documentUpload
] as const

export const REQUIRED_ACTION_TYPES = [...REQUIRED_ACTION_TYPES_BOOKING, ...REQUIRED_ACTION_TYPES_SHIPMENT] as const

export type RequiredActionType = (typeof REQUIRED_ACTION_TYPES)[number]

export const REQUIRED_ACTION_CATEGORIES_BOOKING = ['authorize'] as const
export const REQUIRED_ACTION_CATEGORIES_SHIPMENT = [
  'dataInput',
  'optionChoice',
  'documentUpload',
  'downloadTemplateSignUpload',
] as const

export const DOCUMENT_UPLOAD_ACTION_TYPES = [
  'completePackingList',
  'provideCommercialInvoice',
  'provideCustomsWarrantBelgiumFiscal',
  'provideCustomsWarrantBelgiumPOA',
  'provideCustomsWarrantNetherlandsFiscal',
  'provideCustomsWarrantNetherlandsPOA',
  'provideCustomsWarrantGermanySeaPOA',
  'provideCustomsWarrantGermanyAirPOA',
  'provideCustomsWarrantSelfCustomsDeclaration',
  'provideCustomsWarrantBelgiumExportPOA',
  'provideCustomsWarrantGermanyExportPOA',
  'provideCustomsWarrantGermanyAirExportPOA',
  'provideCustomsWarrantNetherlandsExportPOA',
  'providePaymentProof',
] as const

export const COMPANY_DOCUMENT_UPLOAD_ACTION_TYPES: RequiredActionType[] = [
  'provideCustomsWarrant',
  'provideCustomsWarrantBelgiumFiscal',
  'provideCustomsWarrantBelgiumPOA',
  'provideCustomsWarrantNetherlandsFiscal',
  'provideCustomsWarrantNetherlandsPOA',
  'provideCustomsWarrantGermanySeaPOA',
  'provideCustomsWarrantGermanyAirPOA',
  'provideCustomsWarrantSelfCustomsDeclaration',
  'provideCustomsWarrantBelgiumExportPOA',
  'provideCustomsWarrantGermanyExportPOA',
  'provideCustomsWarrantGermanyAirExportPOA',
  'provideCustomsWarrantNetherlandsExportPOA',
]

export type DocumentUploadActions = (typeof DOCUMENT_UPLOAD_ACTION_TYPES)[number]

export const REQUIRED_ACTION_CATEGORIES = [
  ...REQUIRED_ACTION_CATEGORIES_BOOKING,
  ...REQUIRED_ACTION_CATEGORIES_SHIPMENT,
] as const

export type RequiredActionCategory = (typeof REQUIRED_ACTION_CATEGORIES)[number]

export const requiredActionTypeTranslations: Record<RequiredActionType, string> = {
  provideCustomsWarrantBelgiumFiscal: 'action-item-porath-belgium-import-fiscal',
  provideCommercialInvoice: 'action-item-provide-commercial-invoice',
  provideSealNumbers: 'action_item-provide_seal_numbers',
  providePaymentProof: 'action-item-provide-payment-proof',
  provideBLType: 'action_item-provide-bl-type',
  provideDeliveryDetails: 'action_item-provide_delivery_details',
  completePackingList: 'action-item-complete-packing-list-containers-missing',
  provideFbaData: 'action_item-provide_air_fba_data',
  provideCustomsWarrantGermanyExportPOA: 'action-item-porath-austria-germany-switzerland-export-fcl',
  provideConsigneeInformation: 'action_item-provide_consignee_info',
  provideCustomsWarrantNetherlandsPOA: 'action-item-porath-netherlands-import-power',
  providePickupDetails: 'action_item-provide_pickup_details',
  provideCustomsWarrantBelgiumPOA: 'action-item-porath-belgium-import-power',
  provideSupplierInformation: 'action_item-provide_supplier_info',
  provideIncoTerms: 'action-item-provide-inco-terms',
  provideCustomsWarrantGermanySeaPOA: 'action-item-porath-austria-germany-switzerland-import',
  provideCustomsWarrantNetherlandsFiscal: 'action-item-porath-netherlands-import-fiscal',
  provideCustomsWarrantGermanyAirPOA: 'action-item-zsk-dach-import-power',
  provideCustomsWarrantBelgiumExportPOA: 'action-item-porath-belgium-export-fcl',
  provideCustomsWarrantNetherlandsExportPOA: 'action-item-porath-netherlands-export-fcl',
  provideContainerNumbers: 'action_item-provide_container_numbers',
  provideCustomsWarrantSelfCustomsDeclaration: 'action-item-self-customs-declaration',
  provideCustomsWarrantGermanyAirExportPOA: 'action-item-forto-dach-export-power',
  authorizeBooking: 'action-item-authorize-booking',
  provideCustomsWarrant: 'action-item-provide-customs-warrant',
}

export const getRequiredActionTypeTranslation = (actionType: RequiredActionType, translate: () => string): string => {
  const reqActionTerm = requiredActionTypeTranslations[actionType]
  // @ts-expect-error requiredActionTypeTranslations are a copy of the req action types stored in BE.
  // The term names has to be updated in BE, so that it matches the types.
  return translate(`required-actions.${reqActionTerm}`)
}
